import dynamic from 'next/dynamic';
import { ComponentType } from 'react';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME } from 'utils/constants';
import { useCookieSettings } from 'hooks/useCookieSettings';

import type { CookieBannerProps } from './types';

function CookieBanner() {
  const {
    cookieConsent,
    env: { oneTrustApiKey },
  } = useSiteConfig();

  const { setShowingCookieBannerOT } = useCookieSettings();

  const _cookieConsentProvider = cookieConsent?.provider ?? 'Google';
  const _cookieConsentApiKey = oneTrustApiKey ?? '';
  const _cookieConsentDocumentLanguage =
    cookieConsent?.documentLanguage ?? false;

  let CookieBanner: ComponentType<CookieBannerProps>;

  switch (_cookieConsentProvider) {
    case 'OneTrust':
      CookieBanner = dynamic<CookieBannerProps>(
        () => import(`./OneTrust/CookieBanner`),
        { ssr: false }
      );
      break;

    case 'Google':
    default:
      CookieBanner = dynamic<CookieBannerProps>(
        () => import(`./Google/CookieBanner`),
        { ssr: false }
      );
      break;
  }

  const triggerConsentEvent = () => {
    const event = new Event(COOKIE_BANNER_ACKNOWLEDGED_EVENT_NAME);
    window.dispatchEvent(event);

    setShowingCookieBannerOT(false);
  };

  return (
    <CookieBanner
      apiKey={_cookieConsentApiKey}
      documentLanguage={_cookieConsentDocumentLanguage}
      triggerConsentEvent={triggerConsentEvent}
    />
  );
}

export default CookieBanner;
